/* Poiesis, 28 Oct: the canvas menu (one section open at a time) and the two drawing/carving lines. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- menu: one section open at a time; the current page's section opens with the menu */
  function menus() { return document.querySelectorAll('.pz-nm, .pz-nm-m'); }
  function sync(ul) {
    ul.classList.toggle('has-open', !!ul.querySelector(':scope > li.is-open'));
  }
  function setOpen(ul, li) {
    ul.querySelectorAll(':scope > li').forEach(function (x) {
      var on = x === li;
      x.classList.toggle('is-open', on);
      var b = x.querySelector(':scope > [data-pz-sub]');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    sync(ul);
  }
  function picture(menu, k) {
    menu.querySelectorAll('.pz-fm__img').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fm') === String(k)); });
    menu.querySelectorAll('.pz-fm__item').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fm') === String(k)); });
  }
  function current(menu) {
    var here = location.pathname.replace(/\/$/, '') || '/';
    var hit = null;
    menu.querySelectorAll('.pz-nm__sub a[href]').forEach(function (a) {
      if (hit) return;
      var u = new URL(a.getAttribute('href'), location.href);
      if ((u.pathname.replace(/\/$/, '') || '/') === here && u.pathname !== '/') hit = a.closest('.pz-nm__item');
    });
    return hit;
  }
  function prime(menu) {
    var ul = menu.querySelector('.pz-nm__secs');
    if (!ul) return;
    var li = current(menu);
    setOpen(ul, li);
    picture(menu, li ? li.getAttribute('data-fm') : 3);   /* About */
  }
  menus().forEach(function (menu) {
    var ul = menu.querySelector('.pz-nm__secs');
    menu.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pz-sub]');
      if (!b || !menu.contains(b)) return;
      var li = b.parentNode;
      ul.querySelectorAll(':scope > li.is-open').forEach(function (x) {
        if (x !== li) { x.classList.remove('is-open'); var o = x.querySelector(':scope > [data-pz-sub]'); if (o) o.setAttribute('aria-expanded', 'false'); }
      });
      setTimeout(function () { sync(ul); }, 0);   /* pz.js toggles the clicked one */
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pz-fm-open')) { var d = document.querySelector('.pz-d .pz-nm'); if (d) prime(d); }
    if (e.target.closest('[data-pz-menu]')) { var m = document.querySelector('.pz-m .pz-nm-m'); if (m) prime(m); }
  }, true);

  /* ---------------- Karim (3 Nov): in the About section each page shows its own picture while pointed at -- Poiesis a painted
     and gilded figure, Inami Woodcarving the lion and her falling cub at the Shikidai-mon, the Master Carvers a master at his
     bench. Added here once for every page (menus.PAGE_PIC carries the same for a regenerated menu). */
  (function () {
    var CDN = 'https://cdn.shopify.com/s/files/1/1062/7504/5640/files/';
    var P = [['p-poiesis', 'about-us', 'pz-242-hq.jpg'], ['p-inami', 'inami', 'pz-233-hq.jpg'], ['p-masters', 'the-masters', 'pz-s1126-hq3.jpg']];
    document.querySelectorAll('.pz-nm').forEach(function (menu) {
      var box = menu.querySelector('.pz-nm__pic'), shade = box && box.querySelector('.pz-nm__shade');
      if (!box) return;
      P.forEach(function (p) {
        var a = menu.querySelector('a.pz-nm__pg[href$="/pages/' + p[1] + '"]');
        if (!a || a.hasAttribute('data-fm-pic')) return;
        if (!box.querySelector('.pz-fm__img[data-fm="' + p[0] + '"]')) {
          var sp = document.createElement('span'), im = document.createElement('img');
          sp.className = 'pz-fm__img'; sp.setAttribute('data-fm', p[0]); sp.setAttribute('aria-hidden', 'true');
          im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
          im.src = CDN + p[2] + '?width=1200';
          im.srcset = [600, 900, 1200, 1600, 2000].map(function (w) { return CDN + p[2] + '?width=' + w + ' ' + w + 'w'; }).join(', ');
          im.sizes = '42vw';
          im.style.cssText = 'position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover;object-position:50% 50%';
          sp.appendChild(im);
          box.insertBefore(sp, shade || null);
        }
        a.setAttribute('data-fm-pic', p[0]);
      });
    });
  })();

  /* ---------------- a page with its own picture (the Bridge, Karim 28 Oct): pointing at it or focusing it shows the work;
     leaving it brings back its section's picture, unless the pointer has gone on to another section */
  document.querySelectorAll('.pz-nm').forEach(function (menu) {
    function show(key) {
      menu.querySelectorAll('.pz-fm__img').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-fm') === key); });
    }
    menu.querySelectorAll('a[data-fm-pic]').forEach(function (a) {
      var key = a.getAttribute('data-fm-pic'), li = a.closest('.pz-nm__item');
      function on() { setTimeout(function () { show(key); }, 0); }   /* after the section's own pointerenter / focusin */
      function off() {
        setTimeout(function () {
          if (a.matches(':hover') || document.activeElement === a) return;
          if (li && (li.matches(':hover') || li.contains(document.activeElement))) show(li.getAttribute('data-fm'));
        }, 0);
      }
      a.addEventListener('pointerenter', on); a.addEventListener('focus', on);
      a.addEventListener('pointerleave', off); a.addEventListener('blur', off);
    });
  });

  /* ---------------- a long transom in a swipe strip (phone, home and News): start in the middle, on the pine */
  document.querySelectorAll('[data-pz-pan]').forEach(function (strip) {
    var img = strip.querySelector('img');
    function centre() { if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft = (strip.scrollWidth - strip.clientWidth) / 2; }
    if (img && !img.complete) img.addEventListener('load', centre, { once: true });
    centre();
  });

  /* ---------------- the line between a drawing and the work carved from it */
  function line(input, apply) {
    function go() { apply(+input.value / 100); }
    input.addEventListener('input', go);
    input.addEventListener('change', go);
    go();
  }
  document.querySelectorAll('input[data-pz-cm]').forEach(function (input) {
    var fig = input.closest('figure') || document;
    var clip = fig.querySelector('[data-pz-cm-clip]'), ln = fig.querySelector('[data-pz-cm-line]');
    var dl = fig.querySelector('[data-pz-cm-dl]'), cl = fig.querySelector('[data-pz-cm-cl]');
    line(input, function (f) {
      if (clip) clip.style.clipPath = 'inset(0 ' + (100 - f * 100) + '% 0 0)';
      if (ln) ln.style.left = (f * 100) + '%';
      if (dl) dl.style.opacity = String(0.4 + 0.6 * f);
      if (cl) cl.style.opacity = String(0.4 + 0.6 * (1 - f));
    });
  });
  document.querySelectorAll('input[data-pz-cr]').forEach(function (input) {
    var fig = input.closest('figure') || document;
    var dr = fig.querySelector('[data-pz-cr-draw]'), ca = fig.querySelector('[data-pz-cr-carve]');
    var dl = fig.querySelector('[data-pz-cr-dl]'), cl = fig.querySelector('[data-pz-cr-cl]');
    line(input, function (f) {
      if (dr) dr.style.opacity = String(1 - f);
      if (ca) ca.style.opacity = String(f);
      if (dl) dl.style.opacity = String(0.4 + 0.6 * (1 - f));
      if (cl) cl.style.opacity = String(0.4 + 0.6 * f);
    });
  });
  if (reduce) return;
})();

/* Poiesis, launch (28 Oct): the header's visible height for sticky parts; the Inami chapter rail; the pine drawings trace in. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* --pz-hd-h: how much of the pinned header is on screen (0 when it has slid away), so a sticky rail sits just under it */
  function visibleHead() {
    var hs = document.querySelectorAll('.pz-hd.is-fixed'), h = 0;
    for (var i = 0; i < hs.length; i++) {
      var r = hs[i].getBoundingClientRect();
      if (r.width && r.height && getComputedStyle(hs[i]).visibility !== 'hidden') h = Math.max(h, Math.round(r.bottom));
    }
    return Math.max(0, h);
  }
  var tick = false, zoomOf = function (el) { var z = parseFloat(getComputedStyle(el).zoom); return z > 0 ? z : 1; };
  function setHead() {
    tick = false;
    var px = visibleHead();
    /* the desktop page is zoomed: a CSS length inside it is multiplied by the zoom */
    var d = document.querySelector('.pz-d');
    var z = d && getComputedStyle(d).display !== 'none' ? zoomOf(d) : 1;
    root.style.setProperty('--pz-hd-h', (px / z).toFixed(1) + 'px');
  }
  function queue() { if (!tick) { tick = true; requestAnimationFrame(setHead); } }
  if (document.querySelector('.in-index')) {
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    document.addEventListener('transitionend', function (e) { if (e.target.classList && e.target.classList.contains('pz-hd')) queue(); });
    setTimeout(setHead, 60); setTimeout(setHead, 600);
  }

  /* Inami: the chapter rail marks the chapter being read */
  document.querySelectorAll('.in-index').forEach(function (nav) {
    var links = [].slice.call(nav.querySelectorAll('a[href*="#"]'));
    var scope = nav.closest('.pz-d, .pz-m') || document;
    var map = [];
    links.forEach(function (a) {
      var id = decodeURIComponent(a.getAttribute('href').split('#')[1] || '');
      var t = id && scope.querySelector('[id="' + id.replace(/"/g, '') + '"]');
      if (t) map.push({ a: a, t: t });
    });
    if (!map.length) return;
    function mark() {
      var line = visibleHead() + nav.getBoundingClientRect().height + 40, cur = null;
      map.forEach(function (m) { if (m.t.getBoundingClientRect().top <= line) cur = m; });
      map.forEach(function (m) {
        if (m === cur) m.a.setAttribute('aria-current', 'true'); else m.a.removeAttribute('aria-current');
      });
      if (cur && nav.closest('.pz-m')) {   /* phone: keep the current chapter in view on the swipeable line */
        var ol = cur.a.closest('ol');
        if (ol && ol.scrollWidth > ol.clientWidth) {
          var a = cur.a.getBoundingClientRect(), o = ol.getBoundingClientRect();
          if (a.left < o.left + 12 || a.right > o.right - 12) ol.scrollBy({ left: a.left - o.left - 24, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    }
    var busy = false;
    window.addEventListener('scroll', function () { if (!busy) { busy = true; requestAnimationFrame(function () { busy = false; mark(); }); } }, { passive: true });
    mark();
  });

  /* the pine drawings trace in once, from the heading outward, as they come into view */
  var traces = document.querySelectorAll('[data-pz-trace]');
  if (traces.length && 'IntersectionObserver' in window) {
    /* 3 Nov: watch each drawing's container, not the drawing. The clip-path that hides a drawing before it traces in also
       hides it from IntersectionObserver (zero visible area), so watching the drawing itself never fired and the pines
       stayed hidden. */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var box = en.target, els = box.pzTraces || [];
        io.unobserve(box);
        requestAnimationFrame(function () { els.forEach(function (el) { el.classList.add('is-traced'); el.classList.remove('is-wait'); }); });
      });
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0 });
    traces.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.88 && r.bottom > 0) return;   /* already in view on arrival: leave it drawn */
      var box = el.parentElement;
      if (!box) return;
      el.classList.add('is-wait');
      if (!box.pzTraces) { box.pzTraces = []; io.observe(box); }
      box.pzTraces.push(el);
    });
  }
})();
